import * as React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';


import './_cards.scss';

import {A} from '@atoms/LinksAndButtons/A';
import { LinkStyle, HeadlineLevel, HeadlineFont } from 'features/ui/enums';
import {Icon} from '@atoms/Media/Icon';
import {ResidenceTags} from '@atoms/Tags/ResidenceTags';
import {PremisesObject, PremisesType} from '@pages/PremisesStartPage/types';
import {translatePremiseEnum} from '@pages/PremisesStartPage/helpers';
import {renderInhabitDate} from "features/services/utils/date-helpers";
import {Headline} from '@atoms/Text/Headline';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic table row data
    object: any;
}

export const PremisesTableCard: React.FunctionComponent<Props> = ({object}) => {
    const getPremisesTypes = (type) => {
        let typeString = '';

        type.map((x, index) => {
            typeString += translatePremiseEnum((x as PremisesType));
            if(index !== type.length - 1) typeString += ', '
        });
        return typeString;
    };
    const renderDate = (value: string, data: PremisesObject) => {
        return renderInhabitDate(value, data.inhabitDateEnd, data.inhabitDateDetermined, false, true);
    };

    const classes = classnames('grid-table__card', {
        'grid-table__card--with-tag': object.status,
    });

    return(
        <div className={classes}>
            {object.status && <ResidenceTags premisesStatus={object.status} />}
            <Headline level={HeadlineLevel.H4} font={HeadlineFont.SERIF}>{getPremisesTypes(object.type)}</Headline>
            <dl>
                {object.header && <>
                    <dt><FormattedMessage id='jm.components.Pricelist.size'/></dt>
                    <dd>{object.header}</dd>
                </>}
                {object.inhabitDate && <>
                    <dt><FormattedMessage id='jm.components.Pricelist.inhabitDate'/></dt>
                    <dd>{renderDate(object.inhabitDate, object)}</dd>
                </>}
                {object.objectNumber && <>
                    <dt><FormattedMessage id='jm.components.Pricelist.number'/></dt>
                    <dd>{object.objectNumber}</dd>
                </>}
            </dl>
            {object.url &&
                <>
                    <Icon name="arrow-link" up size={24} />
                    <A
                        href={object.url}
                        route
                        variant={LinkStyle.UNSTYLED}
                        title={object.name}
                    >
                        <span className='visually-hidden'>{object.name}</span>
                    </A>
                </>
            }
        </div>
    )
};
